import { useMemo } from 'react';
import { Platform } from 'react-native';

export default function useAudioContext() {
  const audioContext = useMemo<AudioContext | undefined>(() => {
    const AudioCxt = window.AudioContext || (window as any).webkitAudioContext;
    try {
      if (Platform.OS === 'web') {
        return new AudioCxt();
      }
    } catch (error) {
      console.log(error);
    }
    return undefined;
  }, []);

  return { audioContext };
}
